import React from 'react';
import { EllipsisOutlined } from '@ant-design/icons';
import {Button, Col, ConfigProvider, Pagination, Row, Select, Table} from "antd";
import 'antd/lib/table/style/css';
import 'antd/lib/row/style/css';
import 'antd/lib/col/style/css';
import 'antd/lib/popover/style/css';
import 'antd/lib/button/style/css';
import Dropdown from "antd/es/dropdown";
import getAllWebserviceUsers from '../../../actions/getAllWebserviceUsers';
import createWebserviceUser from '../../../actions/createWebserviceUser';
import updateWebserviceUser from "../../../actions/updateWebserviceUser";
import updateUser from "../../../actions/updateUser";
import deleteWebserviceUser from '../../../actions/deleteWebserviceUser';
import getAllPKIUsers from '../../../actions/getAllPKIUsers';
import createUser from '../../../actions/createUser';
import deleteUser from '../../../actions/deleteUser';
import modalShow from '../../../actions/modalShow';
import modalDismiss from "../../../actions/modalDismiss";
import {ADMIN_USERS_MODAL, ADMIN_WEBSERVICES_MODAL, MESSAGE_MODAL} from '../../Modal/types';
import {connect} from 'react-redux'
import languages from "../../../language/languages";
import esCO from "antd/es/locale/es_ES";
import enUS from "antd/es/locale/en_US";


class AdminTables extends React.Component {

  state = {
    pageSize: 10,
    page: 1,
    sidx: '',
    sord: '',
    filter: false,
  };

  componentDidMount() {
	this.setInitialFilterValues(this.props.reportList.kind);
  }

  handlePageChange = (page) => {
    this.setState({page: page}, () => this.handleChange(this.props.reportList.kind));
  };

  handlePageSizeChange = (value) => {
    this.setState({pageSize: parseInt(value), page: 1}, () => this.handleChange(this.props.reportList.kind));
  };

  handleSort = (pagination, filters, sorter) => {
    if(sorter.columnKey !== undefined) {
      this.setState({sidx: sorter.columnKey, sord: sorter.order}, () => this.handleChange(this.props.reportList.kind));
    } else {
      this.setState({sidx: '', sord: ''}, () => this.handleChange(this.props.reportList.kind));
    }
  };

  handleReportChange = (value) => {
    this.setInitialFilterValues(value);
  };

  handleCreate = () => {
    switch (this.props.reportList.kind) {
      case 'webservices':
        this.props.modalShow({
          modalType: ADMIN_WEBSERVICES_MODAL,
          modalProps: {footer: null, title: languages[this.props.language].create_ip_modal},
          componentProps: {btn: languages[this.props.language].createLabel, disabledFields: false, entryId: null, onSubmit: this.createWSUser}
        });
        break;
      case 'users':
        this.props.modalShow({
          modalType: ADMIN_USERS_MODAL,
          modalProps: {footer: null, title: languages[this.props.language].create_user_modal},
          componentProps: {btn: languages[this.props.language].createLabel, update: false, onSubmit: this.createUser, entryId: null,}
        });
        break;
      default:
        return null;
    }
  };

  afterDelete = (kind) => {
	  this.handleChange(kind);
  };

  updateWebserviceUser = (formValues, file) => {
    this.updateWSUser(formValues,file);
    //this.props.updateWebserviceUser(formValues, file, () => this.handleChange('webservices'));
  };

  handleUpdate = record => {
    switch (this.props.reportList.kind) {
      case 'webservices':
        this.props.modalShow({
          modalType: ADMIN_WEBSERVICES_MODAL,
          modalProps: {footer: null, title: languages[this.props.language].editLabel},
          componentProps: {btn: languages[this.props.language].editLabel, disabledFields: true, entryId: record.ip, onSubmit: this.updateWebserviceUser}
        });
        break;
      case 'users':
        this.props.modalShow({
          modalType: ADMIN_USERS_MODAL,
          modalProps: {footer: null, title: languages[this.props.language].editLabel},
          componentProps: {btn: languages[this.props.language].editLabel, entry:record, entryId: record.userName, onSubmit: this.updateUser, update: true}
        });
        break;
      default:
        return null;
    }
  };

  handleDelete = id => {
    switch (this.props.reportList.kind) {
      case 'webservices':
        this.props.deleteWebserviceUser({ip:id},this.afterDelete);
        break;
      case 'users':
        let message=languages[this.props.language].confirmDeleteUser.replace("{0}",id);
        this.props.modalShow({
          modalType: MESSAGE_MODAL,
          modalProps: {footer: null, title: languages[this.props.language].confirmTitle},
          componentProps: {onOK:() =>{this.props.modalDismiss();this.props.deleteUser({userName:id},this.afterDelete);},btnOK:languages[this.props.language].btnOK,btnCancel:languages[this.props.language].btnCancel,onCancel: () =>{this.props.modalDismiss()},message:message}
        });
        //this.props.deleteUser({userName:id},this.afterDelete);
        break;
      default:
        return null;
    }
  };

  setInitialFilterValues = (value) => {
    switch (value) {
      case 'webservices':
        this.setState({page: 1, sord: 'descend', sidx: 'lastLogin', filter: false}, () =>  this.handleChange(value));
        break;
      case 'users':
        this.setState({page: 1, sord: 'ascend', sidx: 'userName', filter: false}, () =>  this.handleChange(value));
        break;
      default:
        return null;
    }
  };

  handleChange = value => {
    let form={limit:this.state.pageSize, page:this.state.page,orderColumn:  this.state.sidx,asc:  this.state.sord && (this.state.sord==='true' || this.state.sord ==='ascend')};
    switch (value) {
      case 'webservices':
        this.props.getAllWebserviceUsers(form);
        break;
      case 'users':
        this.props.getAllPKIUsers(form);
        break;
      default:
        return null;
    }
  };

  columns = () => {
    switch (this.props.reportList.kind) {
      case 'webservices':
        return [{
          title: languages[this.props.language].ip_column,
          dataIndex: 'ip',
          className: 'mobile-show'
        }, {
          title: languages[this.props.language].name_column,
          dataIndex: 'base64Cert',
          className: 'mobile-hide',
           render: (texto, record) => (
                <span>
                <a href={'data:application/x-x509-ca-cert;base64,' + record.base64Cert}>{record.certSubject}</a>
                </span>
        )
        },
          {
            title: languages[this.props.language].last_login_column,
            dataIndex: 'lastLogin',
            className: 'mobile-show'
          },
          {
          title: languages[this.props.language].actions,
          key: 'action',
          render: (text, record) =>{
            //return this.renderOptions(record);
            return (
              <Dropdown trigger={'click'} overlay={this.renderOptions(record)}>
                <Button type={"primary"} style={{marginLeft: 8}}>
                  <EllipsisOutlined />
                </Button>
              </Dropdown>
            );
            },
          className: 'mobile-show'
        }];
      case 'users':
        return [{
          title: languages[this.props.language].user_column,
          dataIndex: 'userName',
          className: 'mobile-show'
        }, {
          title: languages[this.props.language].status_column,
          dataIndex: 'status',
          className: 'mobile-hide',
          render:(status) => status==='ACTIVE'?languages[this.props.language].activeLabel:languages[this.props.language].changeLabel
        },
          {
          title: languages[this.props.language].role_column,
          dataIndex: 'roleDescription',
          className: 'mobile-show'
        }, {
          title: languages[this.props.language].actions,
          key: 'action',
          render: (text, record) => {
            return (
              <Dropdown trigger={'click'} overlay={this.renderOptions(record)}>
                <Button type={"primary"} style={{marginLeft: 8}}>
                  <EllipsisOutlined />
                </Button>
              </Dropdown>
            );}
          ,
          className: 'mobile-show'
        }];
      default:
        return null;
    }
  };

  renderOptions = (record) => {
    return (
        <div className={'p-20 bg-white'}>
          <Button type={'primary'} htmlType={'button'} onClick={() => this.handleUpdate(record)}>
            {languages[this.props.language].editLabel}
          </Button>
          {this.renderDeleteOption(record)}
        </div>
    );
  };


  renderDeleteOption = (record) => {
    switch (this.props.reportList.kind) {
      case 'users':
        let userName=record.userName;
        if(userName===this.props.userName)
          return '';
        return (
          <Button type={'danger'} htmlType={'button'} onClick={() => this.handleDelete(userName)}>
            {languages[this.props.language].deleteLabel}
            </Button>
        );
      case 'webservices':
        return (
          <Button type={'danger'} htmlType={'button'} onClick={() => this.handleDelete(record.ip)}>
            {languages[this.props.language].deleteLabel}
            </Button>
        );
      default:
        return (
          <Button type={'danger'} htmlType={'button'} onClick={() => this.handleDelete(record.id)}>
            {languages[this.props.language].deleteLabel}
            </Button>
        );
    }
  };

  createUser=(form)=>
  {
      this.props.createUser(form,this.loadData);
  };

  createWSUser=(form,file)=>
  {
    this.props.createWebserviceUser(form,file,this.loadData);
  };

  updateWSUser=(form,file)=>
  {
    this.props.updateWebserviceUser(form,file,this.loadData);
  };

  updateUser=(form)=>
  {
    this.props.updateUser(form,this.loadData);
  };

  loadData=(kind)=>
  {
    this.props.modalDismiss();
    this.setInitialFilterValues(kind);
  };

  renderHeader = () => {
    return(
      <div>
        <Row gutter={16}>
          <Col xs={24} md={8}>
            <Select placeholder={'Acciones'} className={'w-100'} defaultValue={this.props.reportList.kind}
                    onChange={this.handleReportChange}>
              <Select.Option value="users">{languages[this.props.language].user_option}</Select.Option>
              <Select.Option value="webservices">{languages[this.props.language].ip_option}</Select.Option>
            </Select>
          </Col>
          <Col xs={12} md={4}>
            <Button type={'primary'} block className={'float-right'} htmlType={'button'} onClick={this.handleCreate}>
              {languages[this.props.language].createLabel}
            </Button>
          </Col>
        </Row>
      </div>
    );
  };

  render() {
    return (
      <div>
        <ConfigProvider locale={this.props.language==='es'?esCO:enUS}>
        <Table
            columns={this.columns()}
            dataSource={this.props.reportList.entries}
            size={'small'}
            pagination={false}
            title={this.renderHeader}
            rowKey={this.props.reportList.kind === 'webservices' ? 'ip' : this.props.reportList.kind === 'users' ? 'userName' : 'id'}
            onChange={this.handleSort}
        />
        </ConfigProvider>
        <Row className={'p-20'}>
          <Col xs={24} md={8}>
            <span>{languages[this.props.language].results_per_page} </span>
            <Select value={this.state.pageSize} onChange={this.handlePageSizeChange}>
              <Select.Option value="10">10</Select.Option>
              <Select.Option value="20">20</Select.Option>
              <Select.Option value="30">30</Select.Option>
            </Select>
          </Col>
          <Col xs={24} md={16}>
            <Pagination size="small" pageSize={this.state.pageSize} current={this.state.page}
                        onChange={this.handlePageChange} total={this.props.reportList.total}
                        showTotal={(total) => languages[this.props.language].total_elements.replace('$0', total)}/>
          </Col>
        </Row>

      </div>

    );
  }
}

const mapStateToProps = state => {
  return {
    language: state.auth.language,
    reportList: state.users,
    userName: state.auth.userName
  };
};

export default connect(
    mapStateToProps,
    {
      getAllWebserviceUsers,
      modalShow,
      modalDismiss,
      createWebserviceUser,
      deleteWebserviceUser,
      getAllPKIUsers,
      createUser,
      deleteUser,
      updateWebserviceUser,
      updateUser
    })(AdminTables);
